import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status"]
  static values = { delay: { type: Number, default: 1400 } }

  connect() {
    this.timeout = null
  }

  schedule() {
    clearTimeout(this.timeout)
    this.setStatus("Saving...")
    this.timeout = setTimeout(() => this.save(), this.delayValue)
  }

  async save() {
    const formData = new FormData(this.element)

    try {
      const response = await fetch(this.element.action, {
        method: "PATCH",
        body: formData,
        headers: {
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
        }
      })

      if (!response.ok) {
        this.setStatus("Save failed")
        return
      }

      this.setStatus("Saved")
    } catch (_error) {
      this.setStatus("Offline")
    }
  }

  setStatus(message) {
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = message
    }
  }
}
